import type { FC } from 'react';

import Image from 'next/image';

import type { ThumbnailImgProps } from '@yanolja-rnd/nol-design-system';

/**
 * nds에서 thumbnail 컴포넌트에 next/image를 사용하기 위한 컴포넌트
 *
 * @note 현재 peerDependencies로 next/image가 설치되어 있어 UI 패키지에서 next/image를 사용할 수 있다.
 * 주의해야할 것은 next버전이 높아질수록 image 컴포넌트의 default 동작이 변경되거나, props등이 바뀔 수 있으므로
 * 엄밀하게 관리하려면 각 프로젝트에서 해당 컴포넌트를 각각 구현해야한다.
 * 24년 11월 기준으로 display-site에서만 사용하므로 엄격하게 관리하자면 display-site에서 구현하는 것이 맞으나,
 * 현재상황으로 불필요한 props drilling 을 피하고자 편의상 UI 패키지에서 구현하였다.
 * */
export const ImageComponentForThumbnail: FC<ThumbnailImgProps> = ({ alt, className, src, onError }) => {
  return <Image alt={alt} className={className} fill onError={onError} src={src} unoptimized />;
};
